import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c93ce7e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "history" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { style: {"color":"black","font-size":"xx-large"} }, "Submission Histories", -1))
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 2 }
const _hoisted_13 = { key: 3 }

import {handleError, onMounted, ref} from "vue";
import request from '@/api/index'
import store from '@/store'
import {router} from "@/router";


export default /*#__PURE__*/_defineComponent({
  __name: 'voc',
  setup(__props) {

const tableData=ref()
const search=ref("")
function getTableData(){
  request.post('/history/findHistoryByUserNew',{
    username: store.state.username,
  })
      .then((response)=>{
        console.log(response)
        let originData=response.data.data.infoInfos
        console.log("originData: ", originData)

        tableData.value=originData.filter(
            (data) => {
              // console.log(data.datasetName.toLowerCase(), search.value)
              return (!search.value.length) || data.datasetName.toLowerCase().includes(search.value.toString().toLowerCase())
            }
        )
        store.commit('setHistoryRecords', tableData.value)
        console.log("tableData", tableData.value)
      })
      .catch((error)=>{
        console.error(error)
      })
}

getTableData()
// console.log("tableData", tableData.value)

// function handleDelete(index:any,recordData:any){
//   request.post('/history/delete',{
//     historyName: recordData.historyName,
//     username: store.state.username
//   })
//       .then((response)=>{
//         console.log("handleDelete", response)
//         tableData.value.splice(index, 1)
//       })
//       .catch((error)=>{
//         console.log("handleDelete", error)
//       })
// }

function getRecordDetail(index:any, recordData:any) {

  router.push({
    name: 'twodresult',
    params: {
      recordDatasetId: tableData.value[index].datasetId,
      recordName: recordData.historyName
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_el_table, {
      data: tableData.value,
      "default-sort": { prop: ['dateTime'], order: 'descending' },
      style: {"width":"100%"},
      border: false
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          "min-width": "140",
          fixed: "",
          prop: "username",
          label: "user name"
        }),
        _createVNode(_component_el_table_column, {
          "min-width": "140",
          prop: "institute",
          label: "institute"
        }),
        _createVNode(_component_el_table_column, {
          "min-width": "140",
          prop: "morfPath",
          label: "submission type"
        }, {
          default: _withCtx((props) => [
            (props.row.morfPath==='leaderboard')
              ? (_openBlock(), _createElementBlock("text", _hoisted_3, "algorithm (leaderboard)"))
              : (props.row.morfPath==='suggestion')
                ? (_openBlock(), _createElementBlock("text", _hoisted_4, "suggestion/bug/issue"))
                : (_openBlock(), _createElementBlock("text", _hoisted_5, _toDisplayString(props.row.morfPath), 1))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          "min-width": "140",
          prop: "name",
          label: "algorithm name"
        }, {
          default: _withCtx((props) => [
            (props.row.morfPath==='leaderboard')
              ? (_openBlock(), _createElementBlock("text", _hoisted_6, _toDisplayString(props.row.name), 1))
              : (_openBlock(), _createElementBlock("text", _hoisted_7, "N/A"))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          "min-width": "140",
          prop: "lerfPath",
          label: "algorithm type"
        }, {
          default: _withCtx((props) => [
            (props.row.morfPath==='leaderboard')
              ? (_openBlock(), _createElementBlock("text", _hoisted_8, _toDisplayString(props.row.lerfPath), 1))
              : (_openBlock(), _createElementBlock("text", _hoisted_9, "N/A"))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          "min-width": "140",
          prop: "dateTime",
          label: "Submit Time",
          sortable: "sortable"
        }),
        _createVNode(_component_el_table_column, {
          label: "Status",
          "min-width": "160"
        }, {
          default: _withCtx((props) => [
            (props.row.status==='In Process'&&props.row.morfPath!=='suggestion')
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createVNode(_component_el_text, {
                    class: "mx-1",
                    type: "warning",
                    style: {"color":"#FF8017","font-weight":"bold"}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(props.row.status), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]))
              : (props.row.status==='Rejected')
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createVNode(_component_el_text, {
                      class: "mx-1",
                      type: "danger",
                      style: {"color":"#AB140C","font-weight":"bold"}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(props.row.status), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]))
                : (props.row.status==='Approved')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createVNode(_component_el_text, {
                        class: "mx-1",
                        type: "success",
                        style: {"color":"#67C23A","font-weight":"bold"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(props.row.status), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createVNode(_component_el_text, {
                        class: "mx-1",
                        type: "success",
                        style: {"color":"#4C4C4C","font-weight":"bold"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("N/A")
                        ]),
                        _: 1
                      })
                    ]))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])
  ]))
}
}

})